module.exports = __webpack_public_path__ + "img/다크원더러.dd0a95c1.png";